var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.urlOrigin)+" ")]}),(_vm.external)?_c('external-link-icon',{attrs:{"size":"0.8x"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }